module.exports = __webpack_public_path__ + "static/media/face_err.a03e227b.svg";